import { prop } from 'ramda';
import { IRealtyValuation, IPrices } from '../../types/realtyValuation';

export const getAvgPricesSqm = (realtyValuation: IRealtyValuation): IPrices => {
  return prop('avgPricesSqm', realtyValuation);
};
